// extracted by mini-css-extract-plugin
export default {"option":"CurrencyAutocomplete_option__s5IBr","input":"CurrencyAutocomplete_input__nmD3l"};